export default {
  备注: 'Note',
  报价单: 'Quotation',
  协作人: 'Collaborator',
  地址类型: 'Address Type',
  新建客户: 'Create Customer',
  编辑客户: 'Edit Customer',
  新增商机: 'Add Business Opportunity',
  客户导入: 'Import Customer',
  转移客户: 'Transfer Customer',
  客户规模: 'Customer Scale',
  协议: 'Agreement',
  实缴情况: 'Actual Payment Status',
  新增客户: 'Add Customer',
  开票信息: 'Billing Information',
  地址信息: 'Address Information',
  下级实体: 'Subordinate Entity',
  下级客户: 'Subordinate Customer',
  销售合同: 'Sales Contract',
  LP出资信息: 'LP Funds',
  销售订单: 'Sales Order',
  资料沉淀: 'Data Precipitation',
  募资机会: 'Fundraising Opportunity',
  详细地址: 'Detailed Address',
  邮政编码: 'Postal Code',
  抬头类型: 'Title Type',
  开票抬头: 'Billing Title',
  开户银行: 'Opening Bank',
  开户账号: 'Account Number',
  开票地址: 'Billing Address',
  '省份-城市': 'Province-City',
  '省份/城市': 'Province/City',
  商机: 'Business Opportunity',
  基金: 'Fund',
  产品: 'Product',
  基本信息: 'Basic Information',
  报价单列表: 'Quotation List',
  纳税识别号: 'Taxpayer Identification Number',
  关联已有客户: 'Connect With Existing Customer',
  关联已有: 'Connect With Existing ',
  新增开票信息: 'Add New Billing Information',
  新增地址信息: 'Add New Address Information',
  编辑地址信息: 'Edit Address Information',
  编辑开票信息: 'Edit Billing Information',
  线索转化记录: 'Lead Conversion Record',
  客户新增成功: 'Customer Added Successfully',
  老板委托调研人: 'Boss Entrusted Researcher',
  请输入客户名称: 'Please Enter Customer Name',
  协作人查询异常: 'Collaborator Query Exception',
  业务归属区域: 'Business Attribution Area',
  确认移除该开票信息: 'Confirm To Remove This Billing Information',
  确认移除该地址信息: 'Confirm To Remove This Address Information',
  暂无此客户查看权限: 'Temporarily No Permission To View This Customer',
  商机关联客户成功: 'Business Opportunity Successfully Linked To Customer',
  客户名称是必填项: 'Customer Name Is Required',
  客户详情EXCEL模板: 'Customer Detail Excel Template',
  请先保存客户基本信息: 'Please Save The Basic Customer Information First',
  请先保存商机基本信息: 'Please Save The Basic Business Opportunity Information First',
  请先保存产品基本信息: 'Please Save The Basic Product Information First',
  未成交: 'Not traded',
  成交一次: 'Traded Once',
  成交多次: 'Traded Multiple times',
  未出资: 'Not funds',
  出资一次: 'Funds once',
  出资多次: 'Funds Multiple times',
  默认地址: 'Default address',
  默认开票信息: 'Default billing information',
  A类: 'Class A',
  B类: 'Class B',
  C类: 'Class C',
  转移: 'transfer',
  查重: 'Deduplication',
  数据查重: 'Data Deduplication',
  公司名称: 'Company Name'
};
